import calculateCommission from "../helpers/_calculateCommission";

const inputStatus = document.querySelector("select[name=status_id]");
const inputCollected = document.querySelector("input[id=collected]");
const inputHardCost = document.querySelector("input[id=hard-cost]");
const inputConstCommission = document.querySelector("input[id=commision-owed]");
const inputCalcCommision = document.querySelector("input[id=commision-owed-2]");

function eventCalculate() {
    clearValidate();
    
    const amount = Number(inputCollected.value);
    const hard_cost = Number(inputHardCost.value);
    const commision = Number(inputConstCommission.value);
    const cap = Number(inputHardCost.dataset.cap);

    if (hard_cost > amount) {
        errorValidate('"Hard cost" can not be larger than "Collected"', [
            inputCollected,
            inputHardCost,
        ]);
        inputCalcCommision.value = 0;
        return;
    }

    if (cap) {
        const amountXCap = amount * cap;
        if (hard_cost > amountXCap) {
            errorValidate(
                "Hard cost can not be larger than (Amount x Deal Cap)"
            );
            inputCalcCommision.value = 0;
            return;
        }
    }

    const result = calculateCommission(amount, hard_cost, commision);
    inputCalcCommision.value = result.toFixed(2);
}

if (inputCollected) {
    inputCollected.addEventListener("input", (e) => {
        if (!e.target.value) {
            errorValidate("This field can not be empty", [inputCollected]);
            inputCalcCommision.value = "";
            return;
        }
        eventCalculate();
    });
}

if (inputHardCost) {
    inputHardCost.addEventListener("input", (e) => {
        eventCalculate();
    });
}

function clearValidate() {
    try {
        if (inputCollected.classList.contains("error-validate")) {
            inputCollected.classList.remove("error-validate");
            const span = inputCollected.nextElementSibling;
            span.innerHTML = "";
        }

        if (inputHardCost.classList.contains("error-validate")) {
            inputHardCost.classList.remove("error-validate");
            const span = inputHardCost.nextElementSibling;
            span.innerHTML = "";
        }
    } catch (err) {}
}

function errorValidate(message, selectors = []) {
    if (selectors.length) {
        selectors.forEach((input) => {
            if (!input.classList.contains("error-validate")) {
                input.classList.add("error-validate");
                const span = input.nextElementSibling;
                span.innerHTML = message;
            }
        });
    }
}
